export const VIEW_CONTACT_LIST = 79
export const EXPORT_CONTACT_LIST = 80
export const VIEW_CONTACT = 89
export const MANAGE_CONTACT_SSO = 94
export const MANAGE_CONTACT_PROPERTIES = 112